import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { ContainerHeader, TabContainer } from '~components';
import { faFileLines } from '~components/icon';

import FormTemplateList from './FormTemplateList';
import CompletedFormsList from './CompletedFormsList';

const tabs = [
  { id: 'forms-templates', title: 'Templates', component: FormTemplateList },
  { id: 'forms-completed', title: 'Completed Forms', component: CompletedFormsList },
];

// `?tab=` values map to tab indexes so other pages (e.g. the completed-form viewer) can deep-link back
// to a specific tab. Unknown / missing → Templates (0).
const TAB_PARAMS = ['templates', 'completed'];

const FormsContainer: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = Math.max(0, TAB_PARAMS.indexOf(searchParams.get('tab') ?? ''));

  const handleTabChange = (index: number) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', TAB_PARAMS[index]);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="p-2">
      <ContainerHeader icon={faFileLines} iconSize="1x" className="info" dataCy="forms-container-header">
        Custom Forms
      </ContainerHeader>
      <TabContainer tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />
    </div>
  );
};

export default FormsContainer;
